import mapValues from 'lodash-es/mapValues'

export const RENTAL_PORTAL_LISTING_STATUS = {
  closed: 'closed',
  deactivated: 'deactivated',
  draft: 'draft',
  published: 'published',
}

export const RENTAL_PORTAL_LISTING_STATUSES = {
  [RENTAL_PORTAL_LISTING_STATUS.closed]: {
    text: 'RentalPortal.ListingStatusClosedKey',
    textColor: 'var(--color-info)',
  },
  [RENTAL_PORTAL_LISTING_STATUS.deactivated]: {
    text: 'RentalPortal.ListingStatusDeactivatedKey',
    textColor: 'var(--color-warning)',
  },
  [RENTAL_PORTAL_LISTING_STATUS.draft]: {
    text: 'RentalPortal.ListingStatusDraftKey',
    textColor: 'var(--secondary-text-color)',
  },
  [RENTAL_PORTAL_LISTING_STATUS.published]: {
    text: 'RentalPortal.ListingStatusPublishedKey',
    textColor: 'var(--color-success)',
  },
}

export const RENTAL_PORTAL_FACT_SEPARATOR = ' · '

export const RENTAL_PORTAL_VIEWING_STATUS = {
  cancelled: 'cancelled',
  completed: 'completed',
  confirmed: 'confirmed',
  noShow: 'no_show',
  slotOpen: 'slot_open',
}

export const RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN =
  RENTAL_PORTAL_VIEWING_STATUS.slotOpen

export const INTEGRATION_CONNECTION_STATUS = {
  connected: 'connected',
  error: 'error',
  needsReauth: 'needs_reauth',
  notConnected: 'not_connected',
}

export const RENTAL_PORTAL_VIEWING_STATUSES = {
  [RENTAL_PORTAL_VIEWING_STATUS_SLOT_OPEN]: {
    text: 'RentalPortal.ViewingStatusSlotOpenKey',
    textColor: 'var(--color-info)',
  },
  cancelled: {
    text: 'RentalPortal.ViewingStatusCancelledKey',
    textColor: 'var(--color-error)',
  },
  completed: {
    text: 'RentalPortal.ViewingStatusCompletedKey',
    textColor: 'var(--secondary-text-color)',
  },
  confirmed: {
    text: 'RentalPortal.ViewingStatusConfirmedKey',
    textColor: 'var(--color-success)',
  },
  no_show: {
    text: 'RentalPortal.ViewingStatusNoShowKey',
    textColor: 'var(--color-warning)',
  },
}

export const RENTAL_PORTAL_VIEWING_OUTCOME_STATUSES = [
  RENTAL_PORTAL_VIEWING_STATUS.completed,
  RENTAL_PORTAL_VIEWING_STATUS.noShow,
]

export const RENTAL_PORTAL_VIEWING_BOOKED_STATUSES = [
  RENTAL_PORTAL_VIEWING_STATUS.confirmed,
  ...RENTAL_PORTAL_VIEWING_OUTCOME_STATUSES,
]

export const RENTAL_PORTAL_APPLICANT_SOURCE_LABEL_KEY = {
  immoscout24: 'RentalPortal.ApplicantSourceImmoScout24Key',
  immowelt: 'RentalPortal.ApplicantSourceImmoweltKey',
  manual: 'RentalPortal.ApplicantSourceManualKey',
  online_form: 'RentalPortal.ApplicantSourceOnlineFormKey',
}

export const RENTAL_PORTAL_APPLICANT_STAGE_LABEL_KEY = {
  approved: 'RentalPortal.ApplicantStageApprovedKey',
  pool: 'RentalPortal.ApplicantStagePoolKey',
  rejected: 'RentalPortal.ApplicantStageRejectedKey',
  screening: 'RentalPortal.ApplicantStageScreeningKey',
  selected: 'RentalPortal.ApplicantStageSelectedKey',
  withdrawn: 'RentalPortal.ApplicantStageWithdrawnKey',
}

export const RENTAL_PORTAL_APPLICANT_CREDIT_CHECK_STATUSES = {
  consent_given: {
    text: 'RentalPortal.ApplicantCreditCheckStatusConsentGivenKey',
    textColor: 'var(--color-info)',
  },
  consent_pending: {
    text: 'RentalPortal.ApplicantCreditCheckStatusConsentPendingKey',
    textColor: 'var(--color-info)',
  },
  document_attached: {
    text: 'RentalPortal.ApplicantCreditCheckStatusDocumentAttachedKey',
    textColor: 'var(--color-info)',
  },
  expired: {
    text: 'RentalPortal.ApplicantCreditCheckStatusExpiredKey',
    textColor: 'var(--color-warning)',
  },
  not_requested: {
    text: 'RentalPortal.ApplicantCreditCheckStatusNotRequestedKey',
    textColor: 'var(--secondary-text-color)',
  },
  recorded: {
    text: 'RentalPortal.ApplicantCreditCheckStatusRecordedKey',
    textColor: 'var(--color-success)',
  },
  requested: {
    text: 'RentalPortal.ApplicantCreditCheckStatusRequestedKey',
    textColor: 'var(--color-info)',
  },
}

export const RENTAL_PORTAL_APPLICANT_INCOME_PROOF_STATUSES = {
  none: {
    text: 'RentalPortal.ApplicantIncomeProofStatusNoneKey',
    textColor: 'var(--secondary-text-color)',
  },
  uploaded: {
    text: 'RentalPortal.ApplicantIncomeProofStatusUploadedKey',
    textColor: 'var(--color-info)',
  },
  verified: {
    text: 'RentalPortal.ApplicantIncomeProofStatusVerifiedKey',
    textColor: 'var(--color-success)',
  },
}

export const RENTAL_PORTAL_APPLICANT_APPROVAL_STATUSES = {
  approved: {
    text: 'RentalPortal.ApplicantApprovalStatusApprovedKey',
    textColor: 'var(--color-success)',
  },
  pending: {
    text: 'RentalPortal.ApplicantApprovalStatusPendingKey',
    textColor: 'var(--color-info)',
  },
  rejected: {
    text: 'RentalPortal.ApplicantApprovalStatusRejectedKey',
    textColor: 'var(--secondary-text-color)',
  },
}

export const RENTAL_PORTAL_APPLICANT_SCREENING_STATES = {
  clear: {
    text: 'RentalPortal.ApplicantComplianceScreeningStatusClearKey',
    textColor: 'var(--color-success)',
  },
  cleared_false_positive: {
    text: 'RentalPortal.ApplicantComplianceScreeningStatusFalsePositiveKey',
    textColor: 'var(--color-success)',
  },
  confirmed_hit: {
    text: 'RentalPortal.ApplicantComplianceScreeningStatusConfirmedHitKey',
    textColor: 'var(--color-error)',
  },
  error: {
    text: 'RentalPortal.ApplicantComplianceScreeningStatusErrorKey',
    textColor: 'var(--color-error)',
  },
  potential_hit: {
    text: 'RentalPortal.ApplicantComplianceScreeningStatusPotentialHitKey',
    textColor: 'var(--color-warning)',
  },
}

export const RENTAL_PORTAL_APPLICANT_FILTER_LABEL_KEY = {
  approval_status: mapValues(RENTAL_PORTAL_APPLICANT_APPROVAL_STATUSES, 'text'),
  credit_check_status: mapValues(
    RENTAL_PORTAL_APPLICANT_CREDIT_CHECK_STATUSES,
    'text'
  ),
  income_proof_status: mapValues(
    RENTAL_PORTAL_APPLICANT_INCOME_PROOF_STATUSES,
    'text'
  ),
  screening_state: mapValues(RENTAL_PORTAL_APPLICANT_SCREENING_STATES, 'text'),
  source: RENTAL_PORTAL_APPLICANT_SOURCE_LABEL_KEY,
  stage: RENTAL_PORTAL_APPLICANT_STAGE_LABEL_KEY,
}
